import React from "react";
import { quotesRef } from "../firebase";
import { useDeltaSyncedCollection } from "../customHooks/useDeltaSyncedCollection";

const QuotesContext = React.createContext({});

// All quotes created by the user's associated accounts - kept in sync with Firestore through this
// device's cache plus a listener on recently modified documents, so every quote is available to
// list and search, not just recent ones. See useDeltaSyncedCollection.
const QuotesProvider = (props) => {
  const { docs, loading } = useDeltaSyncedCollection(quotesRef);

  return (
    <QuotesContext.Provider value={{ timesheets: docs, loading }}>
      {props.children}
    </QuotesContext.Provider>
  );
};

export { QuotesProvider, QuotesContext };
